import { createStore, getActionIds } from '../../helpers/redux';
import Immutable from 'immutable';

import { ElementTypeActions } from '../../actions/elementType';
// import { CreateElementTypeActions } from '../../actions/forms/createElementType';
import { ProjectActions } from '../../actions/project';

const projectActions = getActionIds(ProjectActions);
const elementTypeActions = getActionIds(ElementTypeActions);
// const createElementTypeActions = getActionIds(CreateElementTypeActions);

const initialState = Immutable.fromJS({
  form: {},
  notifications: {},
  propType: 'String',
});

export const createElementTypeForm = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [elementTypeActions.createElementType.failure]: (state, action) => {
    return state.merge({
      notifications: {
        error: [
          {
            message: action.error[Object.keys(action.error)[0]][0],
          },
        ],
      },
    });
  },
});



// WEBPACK FOOTER //
// ./src/reducers/forms/createElementType.js